import { render, staticRenderFns } from "./MyRoles.vue?vue&type=template&id=03009fa3&scoped=true"
import script from "./MyRoles.vue?vue&type=script&lang=js"
export * from "./MyRoles.vue?vue&type=script&lang=js"
import style0 from "./MyRoles.vue?vue&type=style&index=0&id=03009fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03009fa3",
  null
  
)

export default component.exports